import React, { useEffect, createElement } from 'react';
import { CommerceHeroInfo } from './commerce/CommerceHeroInfo';
import { CommerceHeroForm } from './commerce/CommerceHeroForm';
import { CommerceDistance } from './commerce/CommerceDistance';
import { CommerceWhy } from './commerce/CommerceWhy';
import { CommercePrograms } from './commerce/CommercePrograms';
import { CommerceScheduleLocation } from './commerce/CommerceScheduleLocation';
import { CommerceReviews } from './commerce/CommerceReviews';
import { CommerceFAQHeader } from './commerce/CommerceFAQHeader';
import { CommerceFAQQuestions } from './commerce/CommerceFAQQuestions';
import { CommerceLinks } from './commerce/CommerceLinks';
import { CommerceFinalCTA } from './commerce/CommerceFinalCTA';
export function Commerce() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Commerce, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Storm Taekwondo serves Commerce Township families with premium kids, adult, and family martial arts classes. Claim your free one-week trial.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Storm Taekwondo serves Commerce Township families with premium kids, adult, and family martial arts classes. Claim your free one-week trial.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-710">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-711">
        <div className="absolute inset-0 opacity-20" data-id="element-712">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-713" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-714" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-715">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-716">
            <CommerceHeroInfo data-id="element-717" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-718">
              <CommerceHeroForm data-id="element-719" />
            </div>
          </div>
        </div>
      </section>

      <CommerceDistance data-id="element-720" />
      <CommerceWhy data-id="element-721" />
      <CommercePrograms data-id="element-722" />
      <CommerceScheduleLocation data-id="element-723" />
      <CommerceReviews data-id="element-724" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-725">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-726">
          <CommerceFAQHeader data-id="element-727" />
          <CommerceFAQQuestions data-id="element-728" />
        </div>
      </section>
      <CommerceLinks data-id="element-729" />
      <CommerceFinalCTA data-id="element-730" />
    </div>;
}